import { FeatureId, isFeatureEnabled } from 'services/features/catalog';
import { useGetFeaturesQuery } from 'services/features/api';

export const useFeatureEnabled = (featureId: FeatureId) => {
  const query = useGetFeaturesQuery();
  const isLoading = (query.isLoading || query.isUninitialized) && !query.data && !query.isError;

  return {
    enabled: isFeatureEnabled(query.isError ? undefined : query.data, featureId),
    isLoading,
  };
};
